import { Stack } from "@mui/material";
import type { FC } from "react";
import { DashboardCategorySection } from "web_myplann/Dashboard/Components/DashboardCategorySection";
import { DashboardDetailSkeleton } from "web_myplann/Dashboard/Components/DashboardDetailSkeleton";
import type { DashboardType } from "web_myplann/Dashboard/Components/DashboardTitleCard";
import { useDashboardTotalSections } from "web_myplann/Dashboard/Hooks/useDashboardTotalSections";

type Props = {
	dashboards: DashboardType[];
};

export const DashboardTotalContent: FC<Props> = ({ dashboards }) => {
	const { sections, isLoading } = useDashboardTotalSections(dashboards);

	if (isLoading) {
		return (
			<DashboardDetailSkeleton
				cards={sections.length}
				rowsPerCard={2}
				withHeader
			/>
		);
	}

	return (
		<Stack flex={1} pt={0.8} pb={2} gap={0.8}>
			{sections.map((section) => (
				<DashboardCategorySection
					key={section.overviewType}
					section={section}
				/>
			))}
		</Stack>
	);
};
